import { uniqBy } from 'lodash';

import {
  FETCH_JOURNAL_CONTENT_API_ERRORS_START,
  FETCH_JOURNAL_CONTENT_API_ERRORS_SUCCESS,
  FETCH_JOURNAL_CONTENT_API_ERRORS_FAIL,
  FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_START,
  FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_SUCCESS,
  FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_FAIL,
  CLEAR_JOURNAL_CONTENT_API_ERROR_DETAIL,
} from './action';

const initialState = {
  journalContentApiErrors: {
    items: [],
    total: 0,
    err: null,
  },
  detail: {
    data: null,
    isLoading: false,
    err: null,
  },
  isLoading: true,
  isInitial: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case FETCH_JOURNAL_CONTENT_API_ERRORS_START:
    return {
      ...state,
      journalContentApiErrors: {
        ...state.journalContentApiErrors,
      },
      isLoading: true,
    };
  case FETCH_JOURNAL_CONTENT_API_ERRORS_SUCCESS:
  {
    const incomingItems = Array.isArray(payload.data?.items) ? payload.data.items : [];
    let items = [];
    if (payload.params?.page > 1) {
      items = uniqBy([...state.journalContentApiErrors.items, ...incomingItems], 'id');
    } else {
      items = incomingItems;
    }
    return {
      ...state,
      journalContentApiErrors: {
        ...state.journalContentApiErrors,
        items,
        total: payload.data?.total ?? 0,
      },
      isLoading: false,
      isInitial: true,
    };
  }
  case FETCH_JOURNAL_CONTENT_API_ERRORS_FAIL:
    return {
      ...state,
      journalContentApiErrors: {
        ...state.journalContentApiErrors,
        err: payload,
      },
      isLoading: false,
      isInitial: true,
    };
  case FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_START:
    // Сбрасываем data вместе с err — иначе при быстром переключении строк
    // на доли секунды видна карточка предыдущей ошибки (мигание).
    return {
      ...state,
      detail: {
        ...state.detail,
        isLoading: true,
        err: null,
        data: null,
      },
    };
  case FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_SUCCESS:
    return {
      ...state,
      detail: {
        data: payload,
        isLoading: false,
        err: null,
      },
    };
  case FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_FAIL:
    return {
      ...state,
      detail: {
        ...state.detail,
        isLoading: false,
        err: payload,
      },
    };
  case CLEAR_JOURNAL_CONTENT_API_ERROR_DETAIL:
    return {
      ...state,
      detail: {
        data: null,
        isLoading: false,
        err: null,
      },
    };
  default:
    return { ...state };
  }
};
